import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-image-popup',
  templateUrl: './image-popup.component.html',
  styleUrls: ['./image-popup.component.scss']
})
export class ImagePopupComponent implements OnInit {

  action = new Subject();
  
  constructor() { }

  ngOnInit() {
  }

  close() {
    this.action.next('OK');
  }

}
